const { PDFDocument, PDFName, PDFArray, PDFStream, PDFRef, decodePDFRawStream } = require('pdf-lib');
const xml2js = require('xml2js');



async function extractXfaData(pdfBuffer) {
  const pdfDoc = await PDFDocument.load(pdfBuffer);

  const catalogDict = pdfDoc.catalog;
  const acroFormEntry = catalogDict.lookup(PDFName.of('AcroForm'));
  if (!acroFormEntry) return null;

  let acroFormDict = acroFormEntry;
  if (acroFormEntry instanceof PDFRef) {
    acroFormDict = pdfDoc.context.lookup(acroFormEntry);
  }
  if (!acroFormDict) return null;

  const xfa = acroFormDict.lookup(PDFName.of('XFA'));
  
  const xfaData = {};

  if (xfa instanceof PDFArray) {
    for (let i = 0; i < xfa.size(); i += 2) {
      const name = xfa.lookup(i);
      if (name.asString() === 'datasets') {
        const stream = xfa.lookup(i + 1);
        if (stream instanceof PDFStream) {
          xfaData[name.asString()] = decodeStream(stream);
        }
      }
    }
  } else if (xfa instanceof PDFStream) {
    xfaData['xdp'] = decodeStream(xfa);
  }

  const parser = new xml2js.Parser({
    explicitArray: false,
    tagNameProcessors: [xml2js.processors.stripPrefix]
  });
  
  const result = {};
  for (const [key, xml] of Object.entries(xfaData)) {
    try {
      result[key] = await parser.parseStringPromise(xml);
    } catch (e) {
      result[key] = xml;
    }
  }
  return result;
}

function decodeStream(pdfStream) {
  let decoded = decodePDFRawStream(pdfStream);
  if (decoded && typeof decoded.decode === 'function') {
    decoded = decoded.decode();
  }
  const bytes = decoded.bytes || decoded;
  return Buffer.from(bytes).toString('utf8');
}

async function extractPdf2Json(filebuffer) {

  let data = await extractXfaData(filebuffer)

  return data?.datasets?.datasets?.data?.pdf_anf || null

}

export default extractPdf2Json